import { B } from "../data/pillars";

export default function ServiceCard({ icon, title, sub, subColor, desc, tags }) {
  return (
    <div style={{ background: "#122240", borderRadius: 12, padding: 22, border: "1px solid #1E3A5F" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: subColor + "20", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>{icon}</div>
        <div>
          <div style={{ color: B.white, fontWeight: 700, fontSize: 15 }}>{title}</div>
          <div style={{ color: subColor, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>{sub}</div>
        </div>
      </div>
      <p style={{ color: B.lightGray, fontSize: 13, lineHeight: 1.6, margin: "0 0 14px" }}>{desc}</p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {tags.map(t => (
          <span key={t} style={{ background: "#1A2E4A", border: "1px solid #1E3A5F", color: B.lightGray, fontSize: 10, padding: "3px 8px", borderRadius: 4, fontWeight: 600, letterSpacing: 0.5, textTransform: "uppercase" }}>{t}</span>
        ))}
      </div>
    </div>
  );
}